import { useAtom } from "jotai";
import { FC, useEffect } from "react";
import { permissionsAtom } from "../../atoms/atom";
import AppBar from "../../components/app-bar/AppBar";
import HomeComponent from "../../components/home/Home";
import { useUtils } from "../../utils/utilFunctions";

const Home: FC = () => {
	const [permissions] = useAtom(permissionsAtom);
	const { verifyPermission } = useUtils();

	useEffect(() => {
		if (permissions.length > 0) {
			verifyPermission(permissions, 'INICIO');
		}
	}, [permissions, verifyPermission]);

	return (
		<div className="home">
			<AppBar
				modulo="Início"
			/>
			<HomeComponent/>
		</div>
	);
}

export default Home;